import React, { useEffect } from 'react'
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Nav from '../component/common/nav';
import Home from '../pages/home';
import Footer from '../component/common/footer';
import ProjectsList from '../pages/projects';
import ProjectDetail from '../pages/projectDetails';
import ContactUs from '../pages/contactUs';
import About from '../pages/about';
import Career from '../pages/career';
export default function AppRoute() {
  return (
    <>
      <BrowserRouter>
      <ScrollToTop />
        {/* <ScrollToTop />  Add this here */}
        <Nav />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path="/projects" element={<ProjectsList />} />
          <Route path="/project/:id" element={<ProjectDetail />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/about" element={<About />} />
          <Route path="/career" element={<Career />} />

          {/* <Route path="*" element={<NoPage />} /> */}
        </Routes>
        <Footer />
      </BrowserRouter>

    </>
  )
}


const ScrollToTop = () => {
  const { pathname, hash } = useLocation(); // Get path and hash

  useEffect(() => {
    if (hash) {
      // If there's a hash (e.g., #service), scroll to that element
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    } else {
      // If no hash, scroll to top (e.g., when going back to "/")
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [pathname, hash]); // Re-run on path or hash change

  return null;
}


